export default "__VITE_ASSET__lXi1KtFQ__"